<template>
  <div>
    <skeleton-body :skeleton="skeletonBody" />
    <div class="row" v-if="!skeletonBody">
      <div class="col-12">
        <card>
          <div class="row content-add-btn">
            <div class="col-5" v-if="isCreate()">
              <div class="text-left">
                <button
                  class="btn btn-secondary custom-shadow-btn"
                  @click="$router.push('/certifications/admin/create')"
                >
                  <em class="fa fa-plus"></em>
                  {{ $t('common_words.add_new_record') }}
                </button>
              </div>
            </div>
            <div class="col-12 text-center">
              <hr />
            </div>
            <el-dialog
              top="2%"
              v-if="isShow()"
              :title="$t('common_words.record_selected_threepoints')"
              :visible.sync="modals.read"
              width="80%"
            >
              <p>
                {{ $t('common_words.selected_record_info') }}
              </p>
              <div class="card" v-if="rowData">
                <div class="card-body table-responsive" v-if="rowData">
                  <table aria-describedby="tabla-calidad" class="table">
                    <tbody>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.name') }}:</strong>
                          </h6>
                          {{ rowData.name }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{ $t('common_words.description') }}:</strong
                            >
                          </h6>
                          <template v-if="rowData.description">
                            {{ rowData.description }}
                          </template>
                          <el-tag class="mt-2" v-else type="warning">{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{
                                $t('common_words.type_of_qualification')
                              }}:</strong
                            >
                          </h6>
                          {{ rowData.qualification_type_label }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{ $t('common_words.type_of_capture') }}:</strong
                            >
                          </h6>
                          {{ rowData.capture_type }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{ $t('common_words.record_quantity') }}:</strong
                            >
                          </h6>
                          {{ rowData.total_records }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{ $t('common_words.records_name') }}:</strong
                            >
                          </h6>
                          <template v-if="rowData.record_name">
                            {{ rowData.record_name }}
                          </template>
                          <el-tag class="mt-2" v-else type="warning">{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{
                                $t('common_words.general_percentage_by_task')
                              }}:</strong
                            >
                          </h6>
                          <template v-if="rowData.discount_percentage !== null">
                            {{ rowData.discount_percentage }}
                          </template>
                          <el-tag class="mt-2" v-else type="warning">{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{
                              $t('common_words.associated_companies')
                            }}</strong>
                          </h6>
                          <span
                            v-for="(
                              business, index
                            ) in rowData.businesses_names"
                            :key="index"
                          >
                            <el-tag type="info">{{ business }}</el-tag>
                          </span>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{
                              $t('common_words.associated_profiles2')
                            }}</strong>
                          </h6>
                          <template v-if="rowData.roles_name.length > 0">
                            <span
                              v-for="(role, index) in rowData.roles_name"
                              :key="index"
                            >
                              <el-tag type="info">{{ role }}</el-tag>
                            </span>
                          </template>
                          <el-tag v-else type="warning">{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{
                              $t('common_words.associated_users2')
                            }}</strong>
                          </h6>
                          <template v-if="rowData.users_name.length > 0">
                            <span
                              v-for="(user, index) in rowData.users_name"
                              :key="index"
                            >
                              <el-tag type="info">{{ user }}</el-tag>
                            </span>
                          </template>
                          <el-tag v-else type="warning">{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{ $t('common_words.files') }}</strong>
                          </h6>
                          <template v-if="rowData.evidence !== null">
                            <a
                              style="cursor: pointer"
                              v-for="(
                                fileCertification, index
                              ) in rowData.fileList"
                              :key="index"
                              @click="
                                handleDownload(
                                  rowData.evidence,
                                  fileCertification
                                )
                              "
                            >
                              <el-tag type="info">
                                <em class="fa fa-solid fa-download"></em>
                                {{ fileCertification }}
                              </el-tag>
                            </a>
                          </template>
                          <el-tag type="warning" v-else>{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table mb-4">
                            <strong
                              >{{
                                $t('common_words.sub_associated_category')
                              }}:</strong
                            >
                          </h6>
                          <div
                            v-if="rowData.sub_categories.length > 0"
                            class="row table"
                          >
                            <table
                              aria-describedby="tabla-calidad"
                              class="table"
                            >
                              <thead>
                                <tr>
                                  <td></td>
                                  <td>{{ $t('common_words.mayus_tasks') }}</td>
                                  <td>{{ $t('common_words.mayus_type') }}</td>
                                  <td>
                                    {{
                                      $t('common_words.mayus_associated_value')
                                    }}
                                  </td>
                                  <td>
                                    {{ $t('common_words.product_percentage') }}
                                  </td>
                                  <td>
                                    {{ $t('common_words.value_percentage') }}
                                  </td>
                                  <td>
                                    {{ $t('common_words.photo_questionmark') }}
                                  </td>
                                  <td>
                                    {{
                                      $t('common_words.required_questionmark')
                                    }}
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(
                                    subcat, index
                                  ) in rowData.sub_categories"
                                  :key="index"
                                >
                                  <td>
                                    <el-tag style="height: auto" type="info">
                                      <span
                                        v-tooltip.top-center="
                                          subcat.name.length > 15
                                            ? `${subcat.order} - ${subcat.name}`
                                            : ``
                                        "
                                      >
                                        {{ $t('common_words.order') }}:
                                        {{ subcat.order }}<br />
                                        {{ $t('common_words.name') }}:
                                        {{ subcat.name.substring(0, 15)
                                        }}{{
                                          subcat.name.length > 15 ? `...` : ``
                                        }}<br />
                                        {{ $t('common_words.general') }}:
                                        {{ subcat.general ? 'Si' : 'No' }}<br />
                                        {{ $t('common_words.percentage') }}:
                                        {{
                                          getFormatNumber(
                                            subcat.value_percentage
                                          )
                                        }}%
                                      </span>
                                    </el-tag>
                                  </td>
                                  <td>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-for="(
                                        task, j
                                      ) in subcat.certification_tasks"
                                      :key="j"
                                    >
                                      <span
                                        v-tooltip.top-center="
                                          task.name.length > 32
                                            ? `${task.order} - ${task.name}`
                                            : ``
                                        "
                                      >
                                        {{ task.order }} -
                                        {{ task.name.substring(0, 32)
                                        }}{{
                                          task.name.length > 32 ? `...` : ``
                                        }}
                                      </span>
                                    </p>
                                  </td>
                                  <td>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-for="(
                                        task, j
                                      ) in subcat.certification_tasks"
                                      :key="j"
                                    >
                                      {{ task.calification_type }}
                                    </p>
                                  </td>
                                  <td>
                                    <template
                                      v-for="(
                                        task, j
                                      ) in subcat.certification_tasks"
                                    >
                                      <p
                                        class="d-flex align-items-center size-cell"
                                        :key="j"
                                        v-if="
                                          [
                                            'Fuente de Datos',
                                            'Fuente de Datos Múltiple',
                                          ].includes(task.calification_type)
                                        "
                                      >
                                        {{
                                          task.certification_option_tasks[0]
                                            .data_source_label
                                        }}
                                      </p>
                                      <p
                                        v-tooltip.top-center="
                                          showDialogOptionTask(
                                            task.certification_option_tasks
                                          ).length > 50
                                            ? showDialogOptionTask(
                                                task.certification_option_tasks
                                              )
                                            : ``
                                        "
                                        class="d-flex align-items-center size-cell"
                                        v-else-if="
                                          ['Única', 'Múltiple'].includes(
                                            task.calification_type
                                          )
                                        "
                                      >
                                        {{
                                          showDialogOptionTask(
                                            task.certification_option_tasks
                                          ).substring(0, 50)
                                        }}
                                        {{
                                          showDialogOptionTask(
                                            task.certification_option_tasks
                                          ).length > 50
                                            ? `...`
                                            : ``
                                        }}
                                      </p>
                                      <p
                                        class="d-flex align-items-center size-cell"
                                        v-else-if="
                                          ['Numérica', 'Texto'].includes(
                                            task.calification_type
                                          )
                                        "
                                      >
                                        <label
                                          class="font-weight-light"
                                          style="font-size: 14px"
                                        >
                                          {{
                                            'Min: ' +
                                            roundNumber(task.minimum, 2) +
                                            ' - Max: ' +
                                            roundNumber(task.maximum, 2)
                                          }}
                                        </label>
                                      </p>
                                      <p
                                        class="d-flex align-items-center size-cell"
                                        v-else-if="
                                          task.calification_type == 'Subjetiva'
                                        "
                                      >
                                        <label class="row subject-calification">
                                          <div class="px-0 mr-1">
                                            <el-tag closable type="info">
                                              0
                                            </el-tag>
                                          </div>
                                          ...
                                          <div class="px-0 mr-1">
                                            <el-tag closable type="info">
                                              10
                                            </el-tag>
                                          </div>
                                          ...
                                          <div class="px-0 mr-1">
                                            <el-tag closable type="info">
                                              NA
                                            </el-tag>
                                          </div>
                                        </label>
                                      </p>
                                      <p
                                        class="d-flex align-items-center size-cell"
                                        v-else
                                      >
                                        {{ $t('common_words.does_not_apply') }}
                                      </p>
                                    </template>
                                  </td>
                                  <td>
                                    <template
                                      v-for="(
                                        task, j
                                      ) in subcat.certification_tasks"
                                    >
                                      <p
                                        v-if="true"
                                        class="d-flex align-items-center size-cell"
                                        :key="j"
                                      >
                                        {{
                                          task.discount_percentage
                                            ? `${getFormatNumber(
                                                task.discount_percentage
                                              )}%`
                                            : '--'
                                        }}
                                      </p>
                                    </template>
                                  </td>
                                  <td>
                                    <template
                                      v-for="(
                                        task, j
                                      ) in subcat.certification_tasks"
                                    >
                                      <p
                                        v-if="true"
                                        class="d-flex align-items-center size-cell"
                                        :key="j"
                                      >
                                        {{
                                          task.value_percentage
                                            ? `${getFormatNumber(
                                                task.value_percentage
                                              )}%`
                                            : '--'
                                        }}
                                      </p>
                                    </template>
                                  </td>
                                  <td>
                                    <template
                                      v-for="(
                                        task, j
                                      ) in subcat.certification_tasks"
                                    >
                                      <p
                                        v-if="task.photo_required !== undefined"
                                        class="d-flex align-items-center size-cell"
                                        :key="j"
                                      >
                                        {{
                                          task.photo_required === 1
                                            ? 'Si'
                                            : 'No'
                                        }}
                                      </p>
                                      <p v-else>{{ $t('common_words.no') }}</p>
                                    </template>
                                  </td>
                                  <td>
                                    <template
                                      v-for="(
                                        task, j
                                      ) in subcat.certification_tasks"
                                    >
                                      <p
                                        v-if="task.is_required !== undefined"
                                        class="d-flex align-items-center size-cell"
                                        :key="j"
                                      >
                                        {{
                                          task.is_required === 1 ? 'Si' : 'No'
                                        }}
                                      </p>
                                      <p v-else>{{ $t('common_words.no') }}</p>
                                    </template>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <el-tag
                            type="warning"
                            v-if="rowData.sub_categories.length == 0"
                            >{{
                              $t('common_words.no_sub_associated_category')
                            }}</el-tag
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer footer-date-at" v-if="rowData">
                  <p class="text-muted">
                    <small
                      >{{ $t('common_words.created_on') }}:
                      {{ rowData.created_at }}</small
                    >
                  </p>
                </div>
              </div>
            </el-dialog>
          </div>
          <div v-if="isIndex()">
            <card-header
              :propPagination="pagination"
              @searchedQuery="searchedQuery"
              class="mr-3 mt-4"
            ></card-header>
            <master-table :infoTable="queriedData" :columns="tableColumns">
              <template slot="addColumns">
                <el-table-column
                  :label="$t('common_words.companies')"
                  min-width="120"
                  prop="businesses_names"
                  :resizable="false"
                  :align="`center`"
                >
                  <template slot-scope="scope">
                    <el-badge
                      class="custom-el-badge__content item"
                      v-if="scope.row.businesses_names.length > 0"
                      :hidden="
                        scope.row.businesses_names.length == 1 ? true : false
                      "
                      :value="200"
                      :max="scope.row.businesses_names.length - 1"
                    >
                      <el-button plain type="info" size="small">
                        {{ scope.row.businesses_names[0] }}</el-button
                      >
                    </el-badge>
                  </template>
                </el-table-column>
              </template>
              <template slot="addColumns">
                <el-table-column
                  :label="$t('common_words.sub_category')"
                  min-width="120"
                  prop="sub_categories[0].name"
                  :resizable="false"
                  :align="`center`"
                >
                  <template slot-scope="scope">
                    <el-badge
                      class="custom-el-badge__content item"
                      v-if="scope.row.sub_categories.length > 0"
                      :hidden="
                        scope.row.sub_categories.length == 1 ? true : false
                      "
                      :value="200"
                      :max="scope.row.sub_categories.length - 1"
                    >
                      <el-button plain type="info" size="small">
                        {{ scope.row.sub_categories[0].name }}</el-button
                      >
                    </el-badge>
                  </template>
                </el-table-column>
              </template>
              <template slot="addColumnsOperations">
                <table-columns-operations
                  v-if="isShow()"
                  @handleView="handleView"
                  @handleEdit="handleEdit"
                  @handleDelete="handleDelete"
                  :minWidth="100"
                />
              </template>
            </master-table>
          </div>
          <not-index-permissions v-else />
          <card-footer ref="cardfooter" :propPagination="pagination" />
          <export-tables
            :pdf="{
              filename: 'Certificaciones.pdf',
              route: 'certifications/admin/pdf',
            }"
            :xls="{
              filename: 'Certificaciones.xlsx',
              route: 'certifications/admin/excel',
            }"
          />
          <br />
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { DISK_URL } from 'src/util/Util';
import { MixinExport } from 'src/mixins/mixin-export';
import { Slider } from 'element-ui';
import configTable from './certifications-table';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinNumbers from 'src/util/mixinNumbers';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinSkeleton from 'src/util/mixinSkeleton';
import moment from 'moment';
import SkeletonBody from 'src/components/SkeletonBody.vue';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Slider.name]: Slider,
    [SkeletonBody.name]: SkeletonBody,
  },

  data() {
    return {
      certificationForm: {},
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
      },
      rowData: null,
    };
  },

  computed: { ...configTable().Search },

  mixins: [
    MixinPermissions,
    MixinMasters,
    MixinExport,
    MixinNumbers,
    MixinSkeleton,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    getFormatNumber(value) {
      return Formatter.formatNumber(Number(value));
    },

    showDialogOptionTask(data) {
      const items = data.map(function (item) {
        return item.name;
      });

      return `["${items.join('", "')}"]`;
    },

    handleView(_, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(_, row) {
      row.url_path_form = 'admin/edit';
      this.certificationForm = Object.assign({}, row);
      sessionStorage.setItem(
        'editForm',
        JSON.stringify(this.certificationForm)
      );
      this.$router.push({
        path: 'admin/edit',
      });
    },

    handleDelete(_, row) {
      this.certificationForm = Object.assign({}, row);
      SweetAlert.delete(this.certificationForm.name).then((result) => {
        if (result.value) this.deleteCertification();
      });
    },

    deleteCertification() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.certificationForm.route = 'certifications/admin';
        Axios.destroyMaster(this.certificationForm)
          .then((response) => {
            this.modifyTable(2, this.certificationForm.id, response);
            this.showHideLoading();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'certifications/admin/pdf';
      data.name_file = 'Certificaciones.pdf';
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'certifications/admin/excel';
      data.name_file = 'Certificaciones.xlsx';
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    handleDownload(folder, fileName) {
      const diskName = 'certification_evidences';
      const url = `${DISK_URL}${diskName}/${folder}/${encodeURIComponent(
        fileName
      )}`;
      window.open(url, '_blank');
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      this.setupTable();
      Axios.getMasters('certifications/admin')
        .then((response) => {
          this.hideSkeletonBody();
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((column) => {
              return column.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('certifications');
  },

  destroyed() {
    this.deselectedItemOnMenu('certifications');
  },
};
</script>
